import React from "react";
import ReactDOM from "react-dom/client";
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

import { RouterProvider, createBrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import Router from "./pages";
import UpdatePrompt from "./components/update-prompt/UpdatePrompt";

import "./styles/index.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

if (window.location.hostname === "particify.vercel.app") {
  window.location.replace("https://tutorify.app" + window.location.pathname + window.location.search);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const router = createBrowserRouter(Router, {
  basename: "/",
});

root.render(
    <>
      <RouterProvider router={router} />
      <UpdatePrompt />
      <Analytics />
      <SpeedInsights />
    </>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration: ServiceWorkerRegistration) => {
    window.dispatchEvent(
      new CustomEvent("sw-update-available", { detail: registration })
    );
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
